module.exports = __webpack_public_path__ + "img/cancel_refund.cfdbafe3.png";